
function primaryNavigation () {

	let subNavParents = document.querySelectorAll('.primary-navigation-item.has-children > a');

	for(let i =0; i < subNavParents.length ; i ++) {

		let currEl = subNavParents[i];
		let currElParent = currEl.parentNode;

		currEl.addEventListener('click', (e) => {
			e.preventDefault();
			e.stopPropagation();

			currElParent.classList.toggle('is-active');

		});

		document.addEventListener('click', function(event) {
			let isClickInside = currElParent.contains(event.target);

			if (!isClickInside) {
				currElParent.classList.remove('is-active');
			}

		});
	}
}

export {primaryNavigation}
